var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0382 8.88408C20.6097 5.13731 16.4637 2.85854 11.999 2.81665C7.53424 2.85854 3.38824 5.13731 0.959815 8.88408C-0.319938 10.7622 -0.319938 13.2322 0.959815 15.1103C3.38687 18.8594 7.53311 21.1405 11.999 21.1838C16.4637 21.1419 20.6097 18.8631 23.0382 15.1164C24.3206 13.2368 24.3206 10.7636 23.0382 8.88408ZM20.5533 13.4075C18.6992 16.3483 15.4753 18.1424 11.999 18.1682C8.52266 18.1425 5.29873 16.3483 3.44464 13.4075C2.86663 12.5583 2.86663 11.4421 3.44464 10.5929C5.29868 7.6522 8.52261 5.85805 11.999 5.83227C15.4753 5.858 18.6992 7.6522 20.5533 10.5929C21.1313 11.4421 21.1313 12.5583 20.5533 13.4075Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 16.0209C14.2195 16.0209 16.0197 14.2207 16.0197 12.0001C16.0197 9.77943 14.2195 7.97925 11.9989 7.97925C9.77824 7.97925 7.97806 9.77943 7.97806 12.0001C7.97806 14.2207 9.77824 16.0209 11.9989 16.0209Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.08891fbf54d7ec459e331fb87301fe76.svg";
export { ForwardRef as ReactComponent };